import { useState } from "react";
import S3FileUpload from "../inputs/S3FileUpload";
import S3FileUploadMultipart from "../inputs/S3FileUpload-Multipart";
import { TextField } from "@mui/material";
const TestUpload = () => {
  const [folderId, setFolderId] = useState(3);
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
      <TextField
        label="Test Upload"
        value={folderId}
        onChange={(e) => setFolderId(Number(e.target.value))}
      />
      <S3FileUploadMultipart
        id="test-upload"
        label="Test Upload"
        folderId={folderId}
        onUploadComplete={() => {
          console.log("Upload complete");
        }}
        maxFileSize={260 * 1000 * 1000}
      />
    </div>
  );
};

export default TestUpload;
